var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$parent.isActive)?_c('ActivityList',{key:_vm.card.id,attrs:{"filter":"filter","object-id":_vm.card.id,"object-type":"deck_card","type":"deck"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }